import { useEffect } from 'react';
import { setSEO, createProductSchema, createArticleSchema, createBreadcrumbSchema } from '../utils/seo';

/**
 * SEO хук - компоненттерде SEO басқару үшін
 * @param {Object} seoOptions - SEO параметрлері
 * @param {Array} deps - Тәуелділіктер массиві
 */
export function useSEO(seoOptions = {}, deps = []) {
  useEffect(() => {
    setSEO(seoOptions);
  }, deps);
}

/**
 * Product SEO хук - өнім беттері үшін
 * @param {Object} product - Өнім деректері
 */
export function useProductSEO(product) {
  useEffect(() => {
    if (!product) return;

    const title = product.name;
    const description = product.description?.substring(0, 160) || '';

    setSEO({
      title,
      description,
      keywords: product.category || '',
      ogType: 'product',
      structuredData: createProductSchema(product)
    });
  }, [product]);
}

/**
 * Article SEO хук - жаңалықтар/мақалалар үшін
 * @param {Object} article - Мақала деректері
 */
export function useArticleSEO(article) {
  useEffect(() => {
    if (!article) return;

    const title = article.title;
    const description = article.description?.substring(0, 160) || '';

    setSEO({
      title,
      description,
      ogType: 'article',
      structuredData: createArticleSchema(article)
    });
  }, [article]);
}

/**
 * Breadcrumb SEO хук - навигация тізбегі үшін
 * @param {Array} items - Breadcrumb элементтері [{name, url}]
 */
export function useBreadcrumbSEO(items) {
  useEffect(() => {
    if (!items || items.length === 0) return;

    setSEO({
      structuredData: createBreadcrumbSchema(items)
    });
  }, [items]);
}

export default useSEO;
